
<search
  ref="search"
  class="player-search"
  source="players"
  v-bind="$attrs"
  :placeholder="placeholder"
  v-on="$listeners"
>
  <template #default="slotProps">
    <index-list-item :index="slotProps.item" />
  </template>
</search>
